import { createTracker } from 'usage-tracker';
import { createBusinessUnitSelectChangeTracker } from 'ui-business-units-lib/utils/tracking';
export const StandaloneUsageTracker = createTracker({
  standalone: true
});
export const popoverClickTracker = ({
  objectType,
  value
}) => {
  StandaloneUsageTracker.track('Campaigns Lib', 'Popover Label Clicked', {
    action: 'Popover Label Clicked',
    assetType: objectType,
    campaignId: value
  });
};
export const trackEmptyLabelButtonClicked = ({
  objectType,
  campaignId
}) => {
  StandaloneUsageTracker.track('Campaigns Lib', 'Popover Placeholder Interaction', {
    campaignId,
    objectType
  });
};
export const trackFormCampaignAssociationMade = ({
  formId,
  campaignId,
  entryPoint
}) => StandaloneUsageTracker.track('Campaigns', 'Campaign Form Association', {
  formId,
  campaignId,
  entryPoint
});
export const trackBusinessUnitSelectChange = createBusinessUnitSelectChangeTracker(StandaloneUsageTracker);